var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcReset(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.6654 19.9997C36.6654 29.2047 29.2037 36.6663 19.9987 36.6663C10.7937 36.6663 3.33203 29.2047 3.33203 19.9997C3.33203 10.7947 10.7937 3.33301 19.9987 3.33301V6.66634C16.8633 6.66659 13.8283 7.77177 11.4269 9.78772C9.0255 11.8037 7.41137 14.6014 6.86809 17.6894C6.32482 20.7774 6.88715 23.958 8.4563 26.6725C10.0254 29.387 12.501 31.4617 15.4481 32.532C18.3951 33.6024 21.6251 33.5999 24.5705 32.5251C27.5159 31.4502 29.9883 29.3718 31.5533 26.6549C33.1184 23.938 33.6758 20.7565 33.1279 17.6694C32.5799 14.5822 30.9615 11.787 28.557 9.77467L24.9987 13.333V3.33301H34.9987L30.9204 7.41134C32.7254 8.97433 34.1727 10.9076 35.164 13.0797C36.1553 15.2519 36.6674 17.612 36.6654 19.9997Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcReset);
export default __webpack_public_path__ + "static/media/ic_reset.576b682d2c35421ae12680ff1b5c5dd7.svg";
export { ForwardRef as ReactComponent };